export default "__VITE_ASSET__DRt0yp4e__"